import React, { ChangeEvent, PropsWithChildren } from 'react';
import FormsElementContainer from '../FormsElementContainer/FormsElementContainer';
import FormLabel from '../FormLabel/FormLabel';
import { fileListToArray } from '../../../../../lib/js/Array';
import { InputType } from '../../InputTypes';

/**
 * Simple FormFile Component used in PortalSettings.
 * Do not use in other Forms. This is a deprecated Component.
 */
type FormFileProps = PropsWithChildren<{
  name: string;
  id: string;
  accept: string | string[];
  onChange: (name: string, files: File[], event: ChangeEvent<HTMLInputElement>) => void;
}>;

function FormFile({ name, id, accept, onChange, children }: FormFileProps) {
  return (
    <FormsElementContainer>
      <FormLabel htmlFor={id}>{children}</FormLabel>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <input
        id={id}
        className="form-file__input"
        type={InputType.FILE}
        name={name}
        accept={Array.isArray(accept) ? accept.join(',') : accept}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          // Ensure we always handle an Array of Files
          // This is also done in the newer <FormFileUpload which should be used
          onChange(name, fileListToArray(event.target.files), event);
        }}
      />
    </FormsElementContainer>
  );
}

export default FormFile;
